import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getService,
  getServiceCategory,
  getSubServiceCategory,
} from "../../../api/service";

export const fetchServiceCategory = createAsyncThunk(
  "service-category/list",
  async () => {
    const res = await getServiceCategory();
    return res;
  }
);

export const fetchSubServiceCategory = createAsyncThunk(
  "subservice-category/list",
  async () => {
    const res = await getSubServiceCategory();
    return res;
  }
);

export const fetchService = createAsyncThunk("service", async (payload) => {
  const res = await getService(payload);
  return res;
});

const serviceSlice = createSlice({
  name: "service",
  initialState: {
    isLoading: false,
    isLoadingCategory: false,
    value: {
      serviceCategory: null,
      service: null,
      subserviceCategory: null,
    },
    error: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchServiceCategory.pending, (state) => {
        state.isLoadingCategory = true;
      })
      .addCase(fetchServiceCategory.fulfilled, (state, action) => {
        state.value.serviceCategory = action.payload;
        state.isLoadingCategory = false;
      })
      .addCase(fetchServiceCategory.rejected, (state) => {
        state.isLoading = false;
        state.error = true;
      })
      .addCase(fetchSubServiceCategory.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchSubServiceCategory.fulfilled, (state, action) => {
        state.value.subserviceCategory = action.payload;
        state.isLoading = false;
      })
      .addCase(fetchSubServiceCategory.rejected, (state) => {
        state.isLoading = false;
        state.error = true;
      })
      .addCase(fetchService.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchService.fulfilled, (state, action) => {
        state.value.service = action.payload;
        state.isLoading = false;
      })
      .addCase(fetchService.rejected, (state) => {
        state.isLoading = false;
        state.error = true;
      });
  },
});

export { serviceSlice };
